/**
 * @generated SignedSource<<44eb461fe9c802853609e856f48ee1ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedMostSavedItemsCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_user">;
  readonly " $fragmentType": "HpSharedMostSavedItemsCarousel_user";
};
export type HpSharedMostSavedItemsCarousel_user$key = {
  readonly " $data"?: HpSharedMostSavedItemsCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedMostSavedItemsCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedMostSavedItemsCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarouselModule_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4a2aa8c0161953525bdd5d94ee85569b";

export default node;
